export const sandboxes = {
  suny: {
    color: "#004c93",
    login_url: "https://sunyplay.brightspacedemo.com",
    segment: "HigherEd",
    fields: {
      email: { label: "Campus Email" },
      company: { value: "Suny University" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "New York" },
      phone: { value: "518-320-1100" },
      numOf: { value: "10000" },
      title: false
    },
    contentIds: {
      top: 338484,
      bottom: 338485
    }
  },
  bc: {
    login_url: "https://bctrynow.brightspacedemo.com",
    segment: "K-12",
    fields: {
      email: { label: "School Email" },
      company: { label: "District Name" },
      industry: { value: "K-12" },
      country: { value: "CA" },
      state: { value: "British Columbia" },
      numOf: { value: "10000" },
      title: false,
      marketing: true
    },
    contentIds: {
      top: 354565,
      bottom: 354566
    }
  },
  bill: {
    login_url: "https://billche.brightspacedemo.com",
    meta_title: "Brightspace Sandbox for Bill",
    segment: "HigherEd",
    fields: {
      company: { value: "D2L" },
      industry: { value: "Higher Education" },
      country: { value: "CA" },
      state: { value: "British Columbia" },
      role: {
        options: ["Instructor", "Student"]
      }
    }
  },
  madison: {
    login_url: "https://madison.brightspacedemo.com/",
    meta_title: "Brightspace Sandbox for Madison College",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      title: false,
      company: { value: "Madison College" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "New York" },
      numOf: { value: "10000" }
    },
    contentIds: {
      top: 367413,
      bottom: false
    }
  },
  d2lu: {
    login_url: "https://madison.brightspacedemo.com/",
    meta_title: "Welcome to D2L University",
    segment: "Corporate",
    fields: {
      email: {
        label: "D2L Email"
      },
      title: false,
      company: { value: "D2L" },
      industry: { value: "Corporate" },
      country: { value: "CA" },
      state: { value: "Ontario" },
      numOf: { value: "1000" }
    },
    contentIds: {
      title: 'D2L University',
      top: 368814,
      bottom: false
    }
  },
  event: {
    login_url: "https://d2levents.brightspacedemo.com/",
    meta_title: "We invite you to experience D2L’s Brightspace",
    fields: {
      title: false,
      company: { label: "Organization" },
      industry: true,
      country: true,
      state: true
    },
    contentIds: {
      top: 368968,
      bottom: false
    }
  },
  uhs: {
    login_url: "https://uhs.brightspacedemo.com/",
    meta_title: "Brightspace Sandbox for University of Hawai'i System",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      role: {
        options: ["Instructor", "Student"]
      },
      title: false,
      company: { value: "University of Hawai'i System" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "Hawaii" },
      numOf: { value: "10000" }
    },
    contentIds: {
      top: 368814,
      bottom: false
    }
  },
  utdallas: {
    login_url: "https://utdallas.brightspacedemo.com/",
    meta_title: "Brightspace Sandbox for UT Dallas",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      role: {
        options: ["Instructor", "Student"]
      },
      title: false,
      company: { value: "University of Texas Dallas" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "Texas" },
      numOf: { value: "10000" }
    },
    contentIds: {
      title: 'Welcome UT Dallas',
      top: 369025,
      bottom: false
    }
  },
  utrgv: {
    login_url: "https://utrgv.brightspacedemo.com/",
    meta_title: "Brightspace Sandbox for UTRGV",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      role: {
        options: ["Instructor", "Student"]
      },
      title: false,
      company: { value: "University of Texas Rio Grande Valley" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "Texas" },
      numOf: { value: "10000" }
    },
    contentIds: {
      title: 'Welcome UTRGV',
      top: 369025,
      bottom: false
    }
  },
  eku: {
    color: "#4c151e",
    login_url: "https://ekuedu.brightspacedemo.com/",
    meta_title: "Brightspace Sandbox for Eastern Kentucky University",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      title: false,
      company: { value: "Eastern Kentucky University" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "Kentucky" },
      numOf: { value: "10000" }
    },
    contentIds: {
      title: 'Eastern Kentucky University is trying out D2L’s Brightspace Learning Management System',
      top: 368814,
      bottom: false
    }
  },
  irsc: {
    login_url: "https://uhs.brightspacedemo.com/",
    meta_title: "Brightspace Sandbox for Indian River State College",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      title: false,
      company: { value: "Indian River State College" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "Florida" },
      numOf: { value: "10000" }
    },
    contentIds: {
      title: 'Indian River State College is trying out D2L’s Brightspace Learning Management System',
      top: 368814,
      bottom: false
    }
  },
  ucmo: {
    login_url: "https://ucmo.brightspacedemo.com/",
    meta_title: "Brightspace Sandbox for University of Central Missouri",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      title: false,
      company: { value: "University of Central Missouri" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "Missouri" },
      numOf: { value: "10000" }
    },
    contentIds: {
      title: 'Welcome University of Central Missouri!',
      top: 368814,
      bottom: false
    }
  },
  kctcs: {
    color: "#00467F",
    theme_color: "color-orange",
    meta_title:
      "Brightspace Sandbox for Kentucky Community & Technical College System",
    login_url: "https://kctcs1.brightspacedemo.com",
    segment: "HigherEd",
    fields: {
      email: {
        label: "Campus Email"
      },
      role: {
        options: ["Instructor", "Student"]
      },
      company: { value: "Kentucky Community & Technical College System" },
      industry: { value: "Higher Education" },
      country: { value: "US" },
      state: { value: "Kentucky" },
      phone: { value: "859-256-3100" },
      numOf: { value: "10000" },
      marketing: false
    },
    contentIds: {
      top: 368817,
      bottom: false
    }
  },
  masterclass: {
    meta_title: "Welcome to the D2L Master Class Series",
    theme_color: 'purple-blue',
    login_url: "https://opencourses.desire2learn.com",
    form_heading: "Start your Masterclass today!",
    submit_button: "Start Now",
    sfdc: "7015W0000009rMqQAI",
    fields: {
      email: {
        freedomains: true
      },
      title: false,
      company: { label: "Organization" },
      industry: true,
      country: true,
      state: true,
      phone: false,
      numOf: false,
      checkboxes: {
        name: "masterclass",
        label: "Select your courses",
        error: "Select at least one course",
        options: {
          Accessibility: "Accessibility",
          Inclusive: "Engaging and inclusive Learning Environments",
          LearningFrameworks: "Learning Frameworks",
          Mindset: "Mindset and Mindfulness",
          SEL: "Social Emotional Learning",
          QM: "Quality Learning with Quality Matters"
        }
      },
      marketing: true
    },
    contentIds: {
      top: 363757,
      bottom: 363758
    }
  },
  creator: {
    login_url: "https://create.brightspace.com/",
    theme_color: "color-orange",
    meta_title: "Try Brightspace Creator+ Free",
    form_heading: "Try Creator+ Today",
    submit_button: "Start your Free Trial",
    sfdc: "7015W0000009rMgQAI",
    fields: {
      email: {},
      title: false,
      company: { label: "Organization" },
      industry: true,
      usecase: true,
      country: true,
      state: true,
      phone: true,
      numOf: true,
      marketing: true,
      interest: true
    },
    contentIds: {
      top: 363904,
      bottom: 363906
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/exports/sandboxes.js